'use client' // Error boundaries must be Client Components
import HeaderAndFooterWrapper from '@/components/wrappers/header-and-footer-wrapper'
import type { Metadata } from 'next'

export const metadata: Metadata = {
  title: 'Cherry Lane Theatre: Server Error',
  description: "A server error has occured. We're sorry you got to see this."
}

export default function GlobalError({
  error
}: {
  error: Error & { digest?: string }
}) {
  return (
    <HeaderAndFooterWrapper pathname='/500'>
      <main className='min-w-[360px] pt-[var(--header-height-mobile)] md:pt-[var(--header-height)] h-full'>
        <div
          className='module-container'
          data-error-name={error.name}
          data-error-message={error.message}
        >
          <section className='theme-light spacing-bottom-default spacing-top-default'>
            <div className='grid grid-cols-12 gap-x-3 sm:gap-x-6 max-md:px-6 max-2xl:px-16'>
              <div className='col-span-full row-span-1'>
                <h1
                  className='heading-xl text-heritage-soft-black-full cursor-help'
                  title={JSON.stringify(error, null, 2)}
                >
                  Something went wrong
                </h1>
              </div>
              <div className='col-span-full heading-sm row-span-1 pt-14 pb-12 md:col-span-6 md:pt-24'>
                <p>
                  Something went wrong on our end, and we’re working to clean it
                  up. In the meantime, why not explore other parts of the site?
                  We’ll have this cleaned up soon.
                </p>
                <p className='mt-4'>
                  <span>If you have repeated issues, please email us at</span>
                  &nbsp;
                  <a
                    className='underline hover:no-underline'
                    href={
                      'mailto:help@cherrylanetheatre.org?subject=Something%20went%20wrong'
                    }
                  >
                    help@cherrylanetheatre.org
                  </a>
                  .
                </p>
              </div>
              <div className='col-span-full row-span-1'>
                <a
                  className='button-secondary mb-4 w-full sm:w-auto'
                  aria-label='Back to home'
                  href='/'
                >
                  Back to home
                </a>
              </div>
            </div>
          </section>
        </div>
      </main>
    </HeaderAndFooterWrapper>
  )
}
